var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "login_main"
  }, [_vm._m(0), _c('div', {
    staticClass: "flex items-center space-x-10 mb-8 border-b border-stone-100 pb-0"
  }, [_c('button', {
    staticClass: "iw-login-tab",
    class: {
      active: _vm.login.loginType === 'MOBILE'
    },
    on: {
      "click": function ($event) {
        return _vm.handleloginTypeChange('MOBILE');
      }
    }
  }, [_c('span', {
    staticClass: "font-label text-sm"
  }, [_vm._v($t("haa72", "手机"))])]), _c('button', {
    staticClass: "iw-login-tab",
    class: {
      active: _vm.login.loginType === 'EMAIL'
    },
    on: {
      "click": function ($event) {
        return _vm.handleloginTypeChange('EMAIL');
      }
    }
  }, [_c('span', {
    staticClass: "font-label text-sm"
  }, [_vm._v($t("padf2", "邮箱"))])]), !_vm._isMoile ? _c('button', {
    staticClass: "iw-login-tab",
    class: {
      active: _vm.login.loginType === 'wxLogin'
    },
    on: {
      "click": function ($event) {
        return _vm.handleloginTypeChange('wxLogin');
      }
    }
  }, [_c('span', {
    staticClass: "font-label text-sm"
  }, [_vm._v($t("gpo32", "微信"))])]) : _vm._e()]), _vm.login.loginType === 'wxLogin' ? [_c('div', {
    staticClass: "qrcode-hide weixin-login",
    class: _vm.isProd ? '' : 'qrcode-hide-noprod'
  }, [_c('p', {
    staticClass: "text-sm text-iw-on-surface-variant mb-8"
  }, [_vm._v($t("86foub8", "请使用微信扫一扫"))]), _c('div', {
    staticClass: "qrcodebox"
  }, [_c('QRCODE', {
    ref: "qrcode",
    attrs: {
      "check": true
    },
    on: {
      "login": _vm.onWxLogin
    }
  })], 1)])] : [_vm.login.loginType === 'MOBILE' ? _c('LoginMainMobile', {
    attrs: {
      "login": _vm.login
    },
    on: {
      "no-mobile-email": _vm.noMobileEmail,
      "on-continue-password": _vm.onSubmitMobilePassword,
      "on-continue-code": _vm.onSubmitMobileCode
    }
  }) : _vm._e(), _vm.login.loginType === 'EMAIL' ? _c('LoginMainEmail', {
    attrs: {
      "login": _vm.login
    },
    on: {
      "no-mobile-email": _vm.noMobileEmail,
      "on-continue-password": _vm.onSubmitEmailPassword,
      "on-continue-code": _vm.onSubmitEmailCode
    }
  }) : _vm._e()]], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "font-label text-xs tracking-[0.3em] text-iw-secondary mb-3"
  }, [_vm._v(` ${$t("7be653d", "iWork · 统一工作台")} `)]), _c('h2', {
    staticClass: "text-4xl font-headline tracking-tight text-iw-on-background mb-3"
  }, [_vm._v(` ${$t("e3xsmr4", "欢迎回来")} `)]), _c('p', {
    staticClass: "font-body text-sm text-iw-on-surface-variant"
  }, [_vm._v(` ${$t("mck0epf", "欢迎回来！请继续登录iWork")} `)])]);
}];
export { render, staticRenderFns };